const authRoutes = [
  { path: "/Login", name: "Login", component: "Login" },
  { path: "/OlvidoClave", name: "OlvidoClave", component: "OlvidoClave" },
  {
    path: "/Registro01Plan",
    name: "Registro01Plan",
    component: "Registro01Plan",
  },
  { path: "/Registro02TC", name: "Registro02TC", component: "Registro02TC" },
  {
    path: "/Registro03Usuario",
    name: "Registro03Usuario",
    component: "Registro03Usuario",
  },
  { path: "/Registro04FP", name: "Registro04FP", component: "Registro04FP" },
  {
    path: "/Registro05Completo",
    name: "Registro05Completo",
    component: "Registro05Completo",
  },
  {
    path: "/Renovacion01Plan",
    name: "Renovacion01Plan",
    component: "Renovacion01Plan",
  },
  {
    path: "/Renovacion02TC",
    name: "Renovacion02TC",
    component: "Renovacion02TC",
  },
  {
    path: "/Renovacion03FP",
    name: "Renovacion03FP",
    component: "Renovacion03FP",
  },
  {
    path: "/Renovacion04Completo",
    name: "Renovacion04Completo",
    component: "Renovacion04Completo",
  },
  {
    path: "/login-actualizar-clave/:p_idUsuario",
    name: "LoginActualizarClave",
    component: "LoginActualizarClave",
  },
  {
    path: "/configuracion2FA/:p_idUsuario",
    name: "Configuracion2FA",
    component: "Configuracion2FA",
  },
];

const routes = authRoutes.map(({ path, component }) => ({
  path: `/${path}`,
  name: `${path}`,
  component: () => import(`../views/regLog/${component}.vue`),
}));

export default routes;
